import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20atmospheric%20background%20with%20warm%20amber%20and%20golden%20accents%2C%20abstract%20flowing%20lines%2C%20elegant%20dark%20texture%2C%20subtle%20light%20particles%2C%20cinematic%20mood%2C%20premium%20aesthetic%2C%20no%20text%2C%20smooth%20gradient%20from%20dark%20charcoal%20to%20warm%20umber&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
        alt="H漫画背景"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50" />

      <div className="absolute inset-0 flex items-center justify-center px-4">
        <div className="text-center max-w-3xl w-full">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            最新
            <span className="text-primary-500">H漫画</span>
            在线阅读平台
          </h1>
          <p className="text-base md:text-lg text-white/70 mb-8 max-w-xl mx-auto leading-relaxed">
            收录海量优质H漫画资源，支持在线阅读与下载，每日更新最新H漫画内容，涵盖日系、韩系、国产等多种风格与题材，为成年用户提供流畅安全的浏览体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-base font-semibold transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              立即阅读
              <i className="ri-arrow-right-line ml-2 w-4 h-4 inline-flex items-center justify-center align-middle"></i>
            </Link>
            <Link
              to="/category/japanese"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white rounded-full text-base font-medium backdrop-blur-sm transition-all duration-300 border border-white/20 cursor-pointer whitespace-nowrap"
            >
              日系漫画
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">10,000+</p>
              <p className="text-xs text-white/50 mt-1">漫画资源</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">500万+</p>
              <p className="text-xs text-white/50 mt-1">活跃读者</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">每日更新</p>
              <p className="text-xs text-white/50 mt-1">从不间断</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}